export default __webpack_public_path__ + "static/media/sportsMaster.87f27ba5.jpg";